/* eslint-disable no-undef */

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getReduxActionErrorMessage, isReduxThunkPendingAction, isReduxThunkRejectedAction } from '../core/utils';

import { ApiGatewayUrl } from '../appsettings';
import ErrorException from "src/components/ErrorException";
import Rest from '../core/rest';
import { STATUS_TYPES } from '../core/constants';

const SLICE_NAME = "batchACL";
export const getRequiredData = createAsyncThunk(
    "batchACL/getRequiredData",
    async () => {
        try {
            const response = await Rest.get(ApiGatewayUrl + "/batchacls");
            return response.data;
        }
        catch (ex) {
            ErrorException(ex.response);
        }
    }
)

export const saveBatchAcls = createAsyncThunk(
    "batchACL/saveBatchAcls",
    async (requestData) => {
        try {
            const response = await Rest.post(ApiGatewayUrl + "/batchacls", requestData);
            return response.data;
        }
        catch (ex) {
            ErrorException(ex.response);
        }
    }
)

export const batchACLSlice = createSlice({
    name: 'batchACL',
    initialState: {
        userTabValue: 1,
        camTabValue: 1,
        liveViewAccess: false,
        playbackAccess: false,
        recordAccess: false,
        downloadAccess: false,
        ptzAccess: false,
        expiryDate: null,
        permanentAccess: false,
        userGroups: [],
        camGroups: [],
        //for individual of userSelection
        userSelectedAgencybyIndividual: 0,
        users: [],
        selectedUsers: [],
        userGroupsofEachAgencybyIndividual: [],
        usersofEachGp: [],
        selectedUserGpName: "All User Groups",
        selectedUserGpId: 0,

        // for gp of userSelection
        userSelectedAgencybyGroup: 0,
        selectedUserGroups: [],
        userGroupsofEachAgency: [],

        //for individual of camSelection
        camSelectedAgencybyIndividual: 0,
        cameras: [],
        selectedCams: [],
        camGroupsofEachAgencybyIndividual: [],
        camsofEachGp: [],
        selectedCamGpName: "All Camera Groups",
        selectedCamGpId: 0,

        // for gp of camSelection
        camSelectedAgencybyGroup: 0,
        selectedCamGroups: [],
        camGroupsofEachAgency: [],

        isLoading: false,
        changed: false,
    },
    reducers: {
        userTabValue: (state, action) => {
            state.userTabValue = action.payload;
        },
        camTabValue: (state, action) => {
            state.camTabValue = action.payload;
        },
        liveViewAccess: (state, action) => {
            state.liveViewAccess = action.payload
        },
        playbackAccess: (state, action) => {
            state.playbackAccess = action.payload
        },
        recordAccess: (state, action) => {
            state.recordAccess = action.payload
        },
        downloadAccess: (state, action) => {
            state.downloadAccess = action.payload
        },
        ptzAccess: (state, action) => {
            state.ptzAccess = action.payload
        },
        expiryDate: (state, action) => {
            state.expiryDate = action.payload
        },
        permanentAccess: (state, action) => {
            state.permanentAccess = action.payload
        },
        updateUserGroups: (state, action) => {
            state.userGroups = action.payload
        },
        updateCamGroups: (state, action) => {
            state.camGroups = action.payload
        },

        //for individual of userSelection
        userSelectedAgencybyIndividual: (state, action) => {
            state.userSelectedAgencybyIndividual = action.payload;
        },
        updateUserList: (state, action) => {
            state.users = action.payload
        },
        selectedUsers: (state, action) => {
            state.selectedUsers = action.payload
        },
        usersofEachGp: (state, action) => {
            state.usersofEachGp = action.payload
        },
        userGroupsofEachAgencybyIndividual: (state, action) => {
            state.userGroupsofEachAgencybyIndividual = action.payload
        },
        selectedUserGpName: (state, action) => {
            state.selectedUserGpName = action.payload
        },
        selectedUserGpId: (state, action) => {
            state.selectedUserGpId = action.payload
        },

        //for individual of camSelection
        camSelectedAgencybyIndividual: (state, action) => {
            state.camSelectedAgencybyIndividual = action.payload;
        },
        updateCamList: (state, action) => {
            state.cameras = action.payload
        },
        selectedCams: (state, action) => {
            state.selectedCams = action.payload
        },
        camsofEachGp: (state, action) => {
            state.camsofEachGp = action.payload
        },
        camGroupsofEachAgencybyIndividual: (state, action) => {
            state.camGroupsofEachAgencybyIndividual = action.payload
        },
        selectedCamGpName: (state, action) => {
            state.selectedCamGpName = action.payload
        },
        selectedCamGpId: (state, action) => {
            state.selectedCamGpId = action.payload
        },

        //for gp of userSelection
        userSelectedAgencybyGroup: (state, action) => {
            state.userSelectedAgencybyGroup = action.payload;
        },
        selectedUserGroups: (state, action) => {
            state.selectedUserGroups = action.payload;
        },
        userGroupsofEachAgency: (state, action) => {
            state.userGroupsofEachAgency = action.payload
        },

        // for gp of camSelection
        camSelectedAgencybyGroup: (state, action) => {
            state.camSelectedAgencybyGroup = action.payload;
        },
        selectedCamGroups: (state, action) => {
            state.selectedCamGroups = action.payload;
        },
        camGroupsofEachAgency: (state, action) => {
            state.camGroupsofEachAgency = action.payload
        },

        saveChangedState: (state, action) => {
            state.changed = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            //handle pending actions.
            .addMatcher((action) => isReduxThunkPendingAction(SLICE_NAME, action.type), (state) => {
                return { ...state, isLoading: true, errorMessage: "" };
            })

            //handle rejected actions.   
            .addMatcher((action) => isReduxThunkRejectedAction(SLICE_NAME, action.type), (state, action) => {
                if (action.error && action.error.message === "Aborted") {
                    return {
                        ...state,
                        isLoading: false,
                        statusType: "",
                        actionType: action.type?.split("/")[1],
                        errorMessage: "",
                    };
                } else {
                    return {
                        ...state,
                        isLoading: false,
                        actionType: action.type?.split("/")[1],
                        statusType: STATUS_TYPES.rejected,
                        errorMessage: getReduxActionErrorMessage(action)
                    };
                }
            })
    }
});

export const batchACLActions = batchACLSlice.actions;
export const batchACLState = (state) => state.batchACL;
export default batchACLSlice.reducer;
